import React, { useState, useEffect } from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import styled from 'styled-components';
import { motion } from 'framer-motion';
import FloatingElements from './FloatingElements';

const GallerySection = styled.section`
  padding: 100px 0;
  background-image: url("/images/fondo3.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 2rem;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

const FilterButton = styled.button`
  padding: 0.8rem 1.5rem;
  border: none;
  background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white'};
  color: ${props => props.active ? 'white' : '#333'};
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
`;

const GalleryContainer = styled.div`
  .image-gallery {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }

  .image-gallery-slide {
    transition: all 0.5s ease-in-out;
    
    &.center {
      transform: scale(1);
    }
    
    &.left, &.right {
      transform: scale(0.9);
      opacity: 0.8;
    }
  }

  .image-gallery-slide img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
    
    &:hover {
      transform: scale(1.02);
    }
  }

  .image-gallery-thumbnail {
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateX(5px);
    }
    
    &.active {
      border: 2px solid #667eea;
      transform: scale(1.05);
    }
  }

  .image-gallery-thumbnail img {
    height: 80px;
    object-fit: cover;
  }

  .fullscreen .image-gallery-slide img {
    height: 100vh;
    max-height: 100vh;
    object-fit: contain;
    transform: none;
    
    &:hover {
      transform: none;
    }
  }

  .image-gallery-fullscreen-button {
    padding: 0;
    transition: all 0.3s ease;
    
    &:hover {
      color: #667eea;
      transform: scale(1.1);
    }
  }

  .image-gallery-content.fullscreen {
    background: rgba(0, 0, 0, 0.95);
  }

  .image-gallery-icon {
    transition: all 0.3s ease;
    
    &:hover {
      color: #667eea;
      transform: scale(1.1);
    }
  }

  .image-gallery-bullets {
    .image-gallery-bullet {
      transition: all 0.3s ease;
      border: 2px solid #667eea;
      background: transparent;
      
      &.active {
        background: #667eea;
        transform: scale(1.2);
      }
      
      &:hover {
        background: #764ba2;
        transform: scale(1.1);
      }
    }
  }
`;

const Gallery = () => {
    const galleryData = [
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL CARASUA",
            "largeImage": "images/galeria/carasua1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL CARASUA",
            "largeImage": "images/galeria/carasua2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL CARASUA",
            "largeImage": "images/galeria/carasua3.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL CARASUA",
            "largeImage": "images/galeria/carasua4.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL CARASUA",
            "largeImage": "images/galeria/carasua5.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL  INTERNADO INDIGENA DEL CERRO DE LA TETA",
            "largeImage": "images/galeria/cerro1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL  INTERNADO INDIGENA DEL CERRO DE LA TETA",
            "largeImage": "images/galeria/cerro2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL  INTERNADO INDIGENA DEL CERRO DE LA TETA",
            "largeImage": "images/galeria/cerro3.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL  INTERNADO INDIGENA DEL CERRO DE LA TETA",
            "largeImage": "images/galeria/cerro4.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL  INTERNADO INDIGENA DEL CERRO DE LA TETA",
            "largeImage": "images/galeria/cerro5.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE KASUTALAIN",
            "largeImage": "images/galeria/kasutalain1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE KASUTALAIN",
            "largeImage": "images/galeria/kasutalain2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL KATANAMANA",
            "largeImage": "images/galeria/katanamana1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL KATANAMANA",
            "largeImage": "images/galeria/katanamana2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL KATANAMANA",
            "largeImage": "images/galeria/katanamana3.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL KATANAMANA",
            "largeImage": "images/galeria/katanamana4.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL INDIGENA MALEIWAMANA",
            "largeImage": "images/galeria/maleiwamana1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL INDIGENA MALEIWAMANA",
            "largeImage": "images/galeria/maleiwamana2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL INDIGENA MALEIWAMANA",
            "largeImage": "images/galeria/maleiwamana3.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL INDIGENA MALEIWAMANA",
            "largeImage": "images/galeria/maleiwamana4.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL INDIGENA MALEIWAMANA",
            "largeImage": "images/galeria/maleiwamana5.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL NUMAINA MALEIWA",
            "largeImage": "images/galeria/numain1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL NUMAINA MALEIWA",
            "largeImage": "images/galeria/numain2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL NUMAINA MALEIWA",
            "largeImage": "images/galeria/numain3.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL NUMAINA MALEIWA",
            "largeImage": "images/galeria/numain4.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL NUMAINA MALEIWA",
            "largeImage": "images/galeria/numain5.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE URU",
            "largeImage": "images/galeria/uru1.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE URU",
            "largeImage": "images/galeria/uru2.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE URU",
            "largeImage": "images/galeria/uru3.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE URU",
            "largeImage": "images/galeria/uru4.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN ETNOEDUCATIVA INTEGRAL RURAL DE URU",
            "largeImage": "images/galeria/uru5.jpeg",
            "group": "Uribia - La Guajira"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA EL CARMEN",
            "largeImage": "images/galeria/carmen1.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA EL CARMEN",
            "largeImage": "images/galeria/carmen2.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA EL CARMEN",
            "largeImage": "images/galeria/carmen3.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA EL CARMEN",
            "largeImage": "images/galeria/carmen4.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA EL CARMEN",
            "largeImage": "images/galeria/carmen5.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA OCTAVIO MENDOZA DURAN",
            "largeImage": "images/galeria/octavio1.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA OCTAVIO MENDOZA DURAN",
            "largeImage": "images/galeria/octavio2.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA OCTAVIO MENDOZA DURAN",
            "largeImage": "images/galeria/octavio3.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA OCTAVIO MENDOZA DURAN",
            "largeImage": "images/galeria/octavio4.jpg",
            "group": "El Paso - Cesar"
        },  
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA OCTAVIO MENDOZA DURAN",
            "largeImage": "images/galeria/octavio5.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA POTRERILLO",
            "largeImage": "images/galeria/potrerillo1.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA POTRERILLO",
            "largeImage": "images/galeria/potrerillo2.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA POTRERILLO",
            "largeImage": "images/galeria/potrerillo3.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA POTRERILLO",
            "largeImage": "images/galeria/potrerillo4.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA VALENTIN MANJARREZ",
            "largeImage": "images/galeria/valentin1.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA VALENTIN MANJARREZ",
            "largeImage": "images/galeria/valentin2.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA VALENTIN MANJARREZ",
            "largeImage": "images/galeria/valentin3.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA VALENTIN MANJARREZ",
            "largeImage": "images/galeria/valentin4.jpg",
            "group": "El Paso - Cesar"
        },
        {
            "title": "INSTITUCIÓN EDUCATIVA TECNICA VALENTIN MANJARREZ",
            "largeImage": "images/galeria/valentin5.jpg",
            "group": "El Paso - Cesar"
        }
    ];

    const [activeGroup, setActiveGroup] = useState('all');
    const [images, setImages] = useState([]);

    // Obtener grupos únicos
    const groups = ['all', ...new Set(galleryData.map(item => item.group))];

    useEffect(() => {
        const filteredImages = activeGroup === 'all'
            ? galleryData
            : galleryData.filter(item => item.group === activeGroup);

        const formattedImages = filteredImages.map(item => ({
            original: item.largeImage,
            thumbnail: item.largeImage,
            description: item.title
        }));

        setImages(formattedImages);
    }, [activeGroup]);

    return (
        <GallerySection id="gallery">
            <FloatingElements section="gallery" />
            <Container>
                <Title>Nuestra Galería</Title>

                <FilterContainer>
                    {groups.map(group => (
                        <FilterButton
                            key={group}
                            active={activeGroup === group}
                            onClick={() => setActiveGroup(group)}
                        >
                            {group === 'all' ? 'Todas' : group}
                        </FilterButton>
                    ))}
                </FilterContainer>

                <GalleryContainer>
                    <ImageGallery
                        items={images}
                        showPlayButton={true}
                        showFullscreenButton={true}
                        showBullets={true}
                        slideInterval={3000}
                        slideOnThumbnailOver={true}
                        showIndex={true}
                        showNav={true}
                        showThumbnails={true}
                        thumbnailPosition="left"
                        slideEffect="fade"
                        transitionTime={500}
                        infinite={true}
                        lazyLoad={true}
                    />
                </GalleryContainer>
            </Container>
        </GallerySection>
    );
};

export default Gallery; 